/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../common/components/ModalConfirmation';
import { useKfaTitle } from '../../../common/hooks/useKfaTitle';
import { editHypothesisPath } from '../../../common/services/urlService';
import HypothesisGridCard from '../HypothesisGridCard/HypothesisGridCard';

const HypothesesGrid = ({
  kfasFilteredByTags,
  onDelete,
  projectId,
  dataLength,
  currentPage,
  next,
  hasMore,
  allRetrievedConnections,
}) => {
  const { t } = useTranslation();
  const kfaTitle = useKfaTitle();
  const history = useHistory();
  const noop = () => {};
  const [isDeleteConfirmationVisible, setIsDeleteConfirmationVisible] =
    useState(false);
  const [processDeleteFn, setProcessDeleteFn] = useState(() => noop);

  const handleHideConfirmation = () => setIsDeleteConfirmationVisible(false);

  const handleEditHypothesis = (hypothesisId) =>
    history.push(editHypothesisPath(projectId, hypothesisId));

  const getNextItems = () => {
    const nextPage = currentPage + 1;
    next(nextPage);
  };

  const handleDeleteConfirmation = (hypothesis) => {
    const processConfirmedDeleteForId = () => {
      setIsDeleteConfirmationVisible(false);
      onDelete(hypothesis);
    };
    setProcessDeleteFn(() => processConfirmedDeleteForId);
    setIsDeleteConfirmationVisible(true);
  };

  const hasDataForTagFilters = kfasFilteredByTags.length > 0;
  return (
    <>
      <ModalConfirmation
        show={isDeleteConfirmationVisible}
        onCancel={handleHideConfirmation}
        onConfirm={processDeleteFn}
        confirmTitle={t('areyouSureDeleteMsg')}
        confirmationMessage={t('contentPermanentlyDeleted', {
          contentName: kfaTitle,
        })}
        confirmButtonText={t('yesDelete')}
        dialogClassName="modal-confirmation"
        contentClassName="modal-confirmation"
      />

      <div className="list-grid list-grid-hypotheses" data-testid="list-grid">
        {hasDataForTagFilters && (
          <InfiniteScroll
            dataLength={dataLength}
            hasMore={hasMore}
            next={getNextItems}
            scrollThreshold={0.75}
            className="list-grid"
          >
            {kfasFilteredByTags.map((h, i) => (
              <HypothesisGridCard
                hypothesis={h}
                projectId={projectId}
                onEditMenuClick={handleEditHypothesis}
                onDeleteMenuClick={() => handleDeleteConfirmation(h)}
                index={i}
                key={`content-grid-card-${h.contentThreadId}`}
                allRetrievedConnections={allRetrievedConnections}
              />
            ))}
          </InfiniteScroll>
        )}
      </div>
    </>
  );
};

export default HypothesesGrid;
